<template>
    <v-container class="mw-400">
      <v-card elevation="2">
        <v-card-title class="tableheader white--text">
          <v-icon left color="white">mdi-lock</v-icon>
          Change Password
        </v-card-title>
  
        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submit">
            <v-text-field
              v-model="currentPwd" type="password" label="Current password*"
              :rules="[rules.req]" variant="outlined" />
  
            <v-text-field
              v-model="newPwd" type="password" label="New password*"
              :rules="[rules.req, rules.len]" variant="outlined" />
  
            <v-text-field
              v-model="newPwd2" type="password" label="Confirm new password*"
              :rules="[rules.req, v => v === newPwd || 'Passwords don’t match']"
              variant="outlined" />
  
            <v-btn type="submit" color="primary"
                   :disabled="!valid" :loading="loading">
              Update
            </v-btn>
          </v-form>
  
          <v-alert v-if="msg" class="mt-4"
                   :type="msgType" border="start">
            {{ msg }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import api from '@/services/api'
  import { useRouter } from 'vue-router'
  
  const router = useRouter()
  const currentPwd = ref(''), newPwd = ref(''), newPwd2 = ref('')
  const valid = ref(false), loading = ref(false)
  const msg = ref(''),        msgType = ref('info')
  
  const rules = {
    req: v => !!v || 'Required',
    len: v => v.length >= 8 || 'Min 8 characters'
  }
  
  async function submit () {
    loading.value = true
    try {
      await api.post('/auth/change-password', {
        current_password: currentPwd.value,
        new_password: newPwd.value
      })
      msg.value = 'Password updated – please log in again.'
      msgType.value = 'success'
  
      // optional auto-logout after short delay
      setTimeout(() => router.push('/login'), 2500)
    } catch (err) {
      msg.value = err.response?.data?.error || 'Update failed'
      msgType.value = 'error'
    } finally {
      loading.value = false
    }
  }
  </script>
  